
export const clearAllDataAndRefresh = async () => {
    await clearIndexedDB();
    await clearCaches();
    clearSessionCookies();
    window.location.reload();
}

async function clearIndexedDB() {
    indexedDB.deleteDatabase('amplify-datastore');
}

async function clearCaches() {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map(cache => caches.delete(cache)));
}

function clearSessionCookies() {
    const cookies = document.cookie.split(";");

    for (let cookie of cookies) {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    }
}
